export default __webpack_public_path__ + "static/media/felt.b618ccfb.png";